define('GameDayCore/GDModel/ValueObjects/Resources/SmpteTimecode',['require','exports','module','../ValueObjectFactory','../../../GDUtil/window/Logg'],function(require, exports, module) {
	/**
	 * @class SmpteTimecodeVO
	 * @description Value object for a SMPTE timecode string.
	 * Also contains functions for doing common
	 * manipulations with timecode.
	 */
	var VO = require('../ValueObjectFactory'),
		logg = require("../../../GDUtil/window/Logg");

	VO.create(SmpteTimecode, {
		/**
		 * returns two-character number formatted as a string
		 */
		getFormattedTimeChunk: function ($val) {
			var str = "0" + String($val);
			return str.substr(str.length - 2, 2);
		},

		/**
		 * returns timecode from seconds from midnight
		 */
		secondsToTimecode: function ($seconds, $useColonAsFramesDelimitter) {
			//convert the timecode to a date object. Use midnight of january 1 1970 to get it to start from zero.
			var timecodeAsDate = new Date(1970, 0, 1);

			//set the time as milliseconds from zero
			timecodeAsDate.setTime($seconds * 1000);

			// Note: UTC is used because Date.setTime sets the time in UTC (using seconds since midnight)
			// If Date.hours was used, it would return the hour adjusted for local time, which would be wrong.
			var tmpHours = this.getFormattedTimeChunk(timecodeAsDate.getUTCHours()),
				tmpMinutes = this.getFormattedTimeChunk(timecodeAsDate.getUTCMinutes()),
				tmpSeconds = this.getFormattedTimeChunk(timecodeAsDate.getUTCSeconds()),
				framesDelimiter = ($useColonAsFramesDelimitter != true) ? SEMICOLON : COLON;

			//return the new timecode
			return String(tmpHours + ":" + tmpMinutes + ":" + tmpSeconds + framesDelimiter + "00");
		},

		addSecondsToTimecode: function ($seconds) {
			var totalSeconds = this.timecodeToSeconds(timecode) + $seconds;
			return new GameDayCore.GDModel.SmpteTimecodeVO(this.secondsToTimecode(totalSeconds));
		},

		addMillisToTimecode: function ($milliseconds) {
			//millis arent relevant in timecode, so we'll round it down
			var totalSeconds = this.timecodeToSeconds(timecode) + ($milliseconds / 1000);
			return new GameDayCore.GDModel.SmpteTimecodeVO(this.secondsToTimecode(totalSeconds));
		},

		/**
		 *returns timecode as seconds since midnight
		 */
		secondsSinceMidnight: function () {
			return this.timecodeToSeconds(timecode);
		},

		/**
		 * returns timecode rounded to the nearest ten seconds mark. This is used
		 * to improve cache efficiency when polling the TFS back-end
		 */
		getTimecodeRounded: function () {
			var tmpSeconds = this.timecodeToSeconds(timecode);
			tmpSeconds = Math.floor(tmpSeconds / this.ROUND_TO_SECONDS) * this.ROUND_TO_SECONDS;
			return this.secondsToTimecode(tmpSeconds);
		},

		/**
		 * Gets the string value that we'll pass to the TFS service. This
		 * is a six-digit timecode with no colons or frames, eg 160544
		 */
		getFormattedUrlParam: function () {
			var roundedTc = new GameDayCore.GDModel.SmpteTimecodeVO(this.getTimecodeRounded());
			return roundedTc.hours + roundedTc.minutes + roundedTc.seconds;
		},

		toString: function () {
			return timecode;
		},

		/**
		 *returns timecode as seconds since midnight
		 */
		timecodeToSeconds: function ($timecode) {
			//convert the timecode to a date object. Use midnight of january 1 1970 to get it to start from zero.
			var timecodeAsDate = new Date(1970, 0, 1);

			// Note: UTC is used because Date.time returns seconds since midnight in UTC
			// If Date.hours was used, it would set the hour as local time, which would be adjusted to UTC when Date.time was called.
			timecodeAsDate.setUTCHours(parseFloat($timecode.substr(0, 2)));
			timecodeAsDate.setUTCMinutes(parseFloat($timecode.substr(3, 2)));
			timecodeAsDate.setUTCSeconds(parseFloat($timecode.substr(6, 2)));

			return Math.round(timecodeAsDate.getTime() / 1000);
		}
	});

	function SmpteTimecode($timecodeStr) {
		var vo = VO.ensureVO(this, SmpteTimecode),
			ROUND_TO_SECONDS = 5,
			hours = null,
			minutes = null,
			seconds = null,
			frames = null,
			isValidTimecode = true,
			timecode = parseTimecode($timecodeStr);

		vo.timecode = timecode;
		vo.hours = hours;
		vo.minutes = minutes;
		vo.seconds = seconds;
		vo.frames = frames;
		vo.isValidTimecode = isValidTimecode;
	}

	//parse out the sub-elements of the timecode and validate it here
	function parseTimecode($timecodeStr) {
		var SEMICOLON = ";",
			COLON = ":",
			hours = null,
			minutes = null,
			seconds = null,
			frames = null;
        // create a local var and run some string manip to normalize what was passe in
		var tc = $timecodeStr;
		if (tc.length === 15 && tc.indexOf("_") !== -1) {
            // if it's the right length but gots underscores
			var tc = timecodeStr.split("_")[1];
			tc = tc.substr(0, 2) + ":" + tc.substr(2, 2) + ":" + tc.substr(4, 2);
		} else if (tc.length === 6) {
            // if it's just numbers add colons
			tc = tc.substr(0, 2) + ":" + tc.substr(2, 2) + ":" + tc.substr(4, 2);
		} else { }

        // separate the values by hh mm ss ff
		var vals = tc.split(COLON);
		hours = vals[0];
		minutes = vals[1];

		if (vals.length == 4) {
			seconds = vals[2];
			frames = vals[3];
		} else if (vals.length == 3) {
			//re-split the last value to separate seconds and frames
			if (vals[2].indexOf(SEMICOLON) >= 0) {
				vals = vals[2].split(SEMICOLON);
				seconds = vals[0];
				frames = vals[1];
			} else {
                // if frames weren't included, just append them
				seconds = vals[2];
				frames = "00";
			}
		} else {
            // this $!*# is just jacked. I give up.
			logg.log("Error parsing timecode " + tc);
			isValidTimecode = false;
		}

        // keep dasterdly overages on min / secs / etc -- nothing over 59, please
        // convert everything to seconds
        var allseconds = (parseInt(hours) * 60 * 60) + (parseInt(minutes) * 60) + parseInt(seconds);
        hours  = Math.floor(allseconds / ( 60 * 60 ));
        // subtract the hours-in-seconds from the total
        allseconds -= (hours * ( 60 * 60 ));
        minutes  = Math.floor(allseconds / 60);
        // substract the minutes-in-seconds that as well
        allseconds -= (minutes * 60);
        // what's left? seconds.
        seconds = allseconds;

        // restringify the values and concatenate them for return
        hours = (hours < 10) ? "0" + hours.toString(): hours.toString();
        minutes = (minutes < 10) ? "0" + minutes.toString(): minutes.toString();
        seconds = (seconds < 10) ? "0" + seconds.toString(): seconds.toString();

        tc = hours + ":" + minutes + ":" + seconds;
        return tc;
	}

	return SmpteTimecode;
});
